import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const CalendarIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path
        d="M3.33333 14.6667C2.96667 14.6667 2.65278 14.5361 2.39167 14.275C2.13056 14.0139 2 13.7 2 13.3333V4.00001C2 3.63334 2.13056 3.31945 2.39167 3.05834C2.65278 2.79723 2.96667 2.66668 3.33333 2.66668H4V2.00001C4 1.81112 4.06389 1.65279 4.19167 1.52501C4.31944 1.39723 4.47778 1.33334 4.66667 1.33334C4.85556 1.33334 5.01389 1.39723 5.14167 1.52501C5.26944 1.65279 5.33333 1.81112 5.33333 2.00001V2.66668H10.6667V2.00001C10.6667 1.81112 10.7306 1.65279 10.8583 1.52501C10.9861 1.39723 11.1444 1.33334 11.3333 1.33334C11.5222 1.33334 11.6806 1.39723 11.8083 1.52501C11.9361 1.65279 12 1.81112 12 2.00001V2.66668H12.6667C13.0333 2.66668 13.3472 2.79723 13.6083 3.05834C13.8694 3.31945 14 3.63334 14 4.00001V13.3333C14 13.7 13.8694 14.0139 13.6083 14.275C13.3472 14.5361 13.0333 14.6667 12.6667 14.6667H3.33333ZM3.33333 13.3333H12.6667V6.66668H3.33333V13.3333ZM3.33333 5.33334H12.6667V4.00001H3.33333V5.33334Z"
        fill={color}
      />
    </svg>
  );
};

export default CalendarIcon;
